import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboardApi'
import { useTenantStore } from '../../../shared/stores/useTenantStore'

export const useDashboardSummary = () => {
  const activeMerchantId = useTenantStore((s) => s.activeMerchant?.id)

  return useQuery({
    queryKey: ['dashboard', 'summary', activeMerchantId],
    queryFn: () => dashboardApi.getSummary(),
    enabled: !!activeMerchantId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}

// Simplified hook that returns summary data and states
export const useDashboardSummaryData = () => {
  const { data, isLoading, error, refetch } = useDashboardSummary()
  
  return {
    summary: data,
    isLoading,
    error,
    refetch
  }
}